export const alpPath = (alpId: Number) => `/alp/${alpId}`;
